import { HelperServiceClient } from 'pbts/c1/api/copilot_cel/v1/private/copilot_cel.client'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export const getCELHelper = createUnaryApi(
    HelperServiceClient,
    'get',
)
